module.exports = __webpack_public_path__ + "img/banner_bg_PT.3d625cc4.png";